import { SuccessResult } from "./SuccessResult";

export const PlanDowngradeCancelSuccessResult: React.FC = () => {
  return (
    <SuccessResult
      title="Plan downgrade is canceled"
      text="Your plan will stay the same on your next billing cycle."
    />
  );
};
